import { set } from '@/utils/vuex'
export default {
  listClientsRecords: set('listClientsRecords'),
  listClientsState: set('listClientsState'),
  editClientState: set('editClientState')
}
